import NewOption from './NewOption'

export default NewOption



// WEBPACK FOOTER //
// ./src/components/Options/New/index.js